module.exports = __webpack_public_path__ + "img/icon-cexiao.8ec599d3.png";